module.exports = __webpack_public_path__ + "static/media/mtn25.06f46e33.geojson";